module.exports = __webpack_public_path__ + "static/media/raftofthemedusa3.ddf3ff0d.jpg";